import {Component, OnInit} from '@angular/core';
import {LayoutService} from '../../layout.service';
import { NotificationService } from 'app/core/services/notification.service';
import { AuthenticationService } from 'app/+auth/+login/authentication.service'; 

declare var $: any;

@Component({
  selector: 'sa-user-manual',
  templateUrl: './user-manual.component.html'
})
export class UserManualComponent implements OnInit {

  displayPDFDialog = false;
  modal: any ;
  responseFinal  :any ;
  messageResponse : string ="";
  viewMessageResponse : boolean = false ;  
  pdfSrc: string;
  datai18n : any;
  title: string;
  currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  constructor(
    private layoutService: LayoutService,
    private notificationService :  NotificationService,
    private authenticationService: AuthenticationService,
  ) {

  }

  ngOnInit() {
    this.modal ={} 
    this.datai18n = JSON.parse(localStorage.getItem('datai18n'));
    this.title = this.datai18n['Header.userManual'];
  }

  onToggle() {
    this.layoutService.onCollapseMenu()
  }

  onUserManual(){
    this.displayPDFDialog  = true ; 
    this.authenticationService.downloadUserManual( this.currentUser.userSystem.executingUnit.id
    ).subscribe(data => {
      //console.log(data);
      
      
      const reader = new FileReader();
      //console.log(reader);
      reader.onload = (e: any) => {
        //console.log(e);
        this.pdfSrc = e.target.result;
        //console.log(this.pdfSrc);
      }
      reader.readAsArrayBuffer(data);
      //console.log(reader);
    });
  }
     
    

  exitPDFDialog(){
      this.displayPDFDialog = false ;
      this.modal ={};
    }

    downloadUserManual(){
      
      this.authenticationService.downloadUserManual( this.currentUser.userSystem.executingUnit.id
      ).subscribe(data => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.href = url;
        a.download = this.datai18n['UserManual.nameFile.download'] + '.pdf';
        a.click();
        return url;
      });
    }

    
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/user-manual/user-manual.component.ts